import { Link } from "react-router-dom";
import { BAY_ISLE, TERRACOTTA, SEMI_SWEET, PROPER_GREY, RULE, WHITE, FONT_DISPLAY, FONT_DISPLAY_HEAVY, FONT_SERIF, FONT_BODY } from "../theme";
import Testimonials from "../components/Testimonials";
import { TESTIMONIALS } from "../data/testimonials";

const HOME_REVIEWS = TESTIMONIALS.filter(t => ["agent", "business", "community"].includes(t.audience));

function PillarCard({ icon, title, desc, to }) {
  return (
    <Link to={to} style={{
      display: "block", textDecoration: "none", background: WHITE,
      border: `1px solid ${RULE}`, borderRadius: 14, padding: "22px 20px",
      transition: "border-color 0.18s, transform 0.18s",
    }}>
      <div style={{
        width: 38, height: 38, borderRadius: 10, background: "rgba(195,135,98,0.1)",
        display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14,
      }}>
        <i className={`ti ${icon}`} aria-hidden="true" style={{ fontSize: 19, color: TERRACOTTA }} />
      </div>
      <p style={{ fontSize: 15, fontWeight: 700, color: BAY_ISLE, marginBottom: 6, fontFamily: FONT_DISPLAY }}>{title}</p>
      <p style={{ fontSize: 12.5, color: PROPER_GREY, lineHeight: 1.55, fontFamily: FONT_BODY, marginBottom: 10 }}>{desc}</p>
      <span style={{ fontSize: 11.5, fontWeight: 700, color: TERRACOTTA, fontFamily: FONT_BODY }}>Learn more →</span>
    </Link>
  );
}


export default function Home() {
  return (
    <div>
      {/* HERO */}
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "4rem 20px 3rem", textAlign: "center" }}>
        <p style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase",
          color: TERRACOTTA, borderBottom: `1.5px solid ${TERRACOTTA}`,
          display: "inline-block", paddingBottom: 4, marginBottom: 20, fontFamily: FONT_BODY,
        }}>
          Hudson Valley, NY
        </p>
        <h1 style={{
          fontFamily: FONT_DISPLAY_HEAVY, fontSize: "clamp(28px, 6vw, 46px)",
          color: BAY_ISLE, lineHeight: 1.15, marginBottom: 18, fontWeight: 400,
        }}>
          The smarter way to{" "}
          <em style={{ color: TERRACOTTA, fontStyle: "italic", fontFamily: FONT_SERIF, fontSize: "1.1em" }}>
            show up
          </em>{" "}
          online
        </h1>
        <p style={{
          fontSize: 15, color: SEMI_SWEET, lineHeight: 1.75, maxWidth: 480,
          margin: "0 auto 28px", fontFamily: FONT_BODY,
        }}>
          Acadia is an AI-powered marketing partner for Hudson Valley real estate agents
          and small businesses. We do the AI production work you don't have time for —
          virtual staging, listing copy, reels, and content, all done for you.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          <Link to="/get-started" className="btn-primary" style={{ textDecoration: "none", display: "inline-block" }}>
            Get Started →
          </Link>
          <Link to="/for-agents" style={{
            textDecoration: "none", display: "inline-block", padding: "14px 24px",
            borderRadius: 9, border: `1px solid ${RULE}`, background: WHITE,
            fontSize: 11.5, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
            color: BAY_ISLE, fontFamily: FONT_BODY,
          }}>
            For Agents
          </Link>
        </div>
      </div>

      {/* PILLARS */}
      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "0 20px 4rem" }}>
        <p style={{
          textAlign: "center", fontSize: 10, fontWeight: 700, letterSpacing: "0.2em",
          textTransform: "uppercase", color: PROPER_GREY, marginBottom: 28, fontFamily: FONT_BODY,
        }}>
          What we do
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 14 }}>
          <PillarCard
            icon="ti-home"
            title="AI Listing Boost"
            desc="Virtual staging, listing copy, social captions, and an auto-captioned reel — delivered in 48 hours."
            to="/for-agents"
          />
          <PillarCard
            icon="ti-sparkles"
            title="AI, Done For You"
            desc="You don't need to learn AI. We use it to do the production work — you bring the relationships."
            to="/for-agents"
          />
          <PillarCard
            icon="ti-building-store"
            title="For Local Businesses"
            desc="Social content, captions, and reels — AI-produced and on-brand, without the learning curve."
            to="/for-businesses"
          />
          <PillarCard
            icon="ti-code"
            title="Custom AI Builds"
            desc="AI-powered websites, tools, and digital assets — built to spec. Fully custom, fully yours."
            to="/get-started"
          />
        </div>
      </div>

      {/* TESTIMONIALS */}
      <Testimonials reviews={HOME_REVIEWS} dark={false} label="Client stories" />

      {/* CTA BAND */}
      <div style={{ background: TERRACOTTA, padding: "3rem 20px", textAlign: "center" }}>
        <p style={{
          fontFamily: FONT_SERIF, fontStyle: "italic", fontSize: 22,
          color: WHITE, marginBottom: 18, maxWidth: 480, margin: "0 auto 18px",
        }}>
          "AI becomes your assistant — not the product."
        </p>
        <Link to="/get-started" style={{
          textDecoration: "none", display: "inline-block", padding: "14px 28px",
          borderRadius: 9, background: WHITE, color: TERRACOTTA,
          fontSize: 11.5, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
          fontFamily: FONT_BODY,
        }}>
          Work with us →
        </Link>
      </div>
    </div>
  );
}
